'use client';
import { useEffect } from 'react';

import * as Sentry from '@sentry/nextjs';
import { useTranslations, useLocale } from 'next-intl';

import Breadcrumbs from '@/ui/components/Breadcrumbs';
import { ErrorContainer, ErrorTitle, ErrorMessage, RetryButton } from './index.styled';

/**
 * @todo translate
 * @todo sentry
 */
export default function ClientError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const translate = useTranslations();
  const locale = useLocale();

  // Build locale-specific URL for support homepage
  const supportUrl = locale === 'en' ? '/' : `/${locale}`;

  useEffect(() => {
    console.error(error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <>
      <Breadcrumbs
        items={[
          { name: translate('breadcrumb-support'), url: supportUrl },
          { name: translate('client-error-fallback-ui-title') },
        ]}
      />
      <ErrorContainer>
        <ErrorTitle>{translate('client-error-fallback-ui-title')}</ErrorTitle>
        <ErrorMessage>{error.message || translate('client-error-fallback-ui-default-message')}</ErrorMessage>
        <RetryButton onClick={reset}>{translate('client-error-fallback-ui-button')}</RetryButton>
      </ErrorContainer>
    </>
  );
}
